import { fetchData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export const validateMappingsAPI = async (payload: any) => {
  const response = await fetchData<any[]>(API_ENDPOINTS.SCENARIO_INPUT.VALIDATE_PACK_SIZE_BY_CATEGORY, payload);
  return response;
};
